module.exports = __webpack_public_path__ + "img/QRMLogo.463cac94.png";